/**
 * In-memory company logo for the new-customer wizard.
 * Files cannot be persisted in sessionStorage, so this survives step navigation
 * only within the current browser tab session.
 */

let companyLogoFile: File | null = null;

export function setCompanyLogoFile(file: File | null): void {
  companyLogoFile = file;
}

export function getCompanyLogoFile(): File | null {
  return companyLogoFile;
}

export function clearCompanyLogoFile(): void {
  companyLogoFile = null;
}
